import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { UserService } from '../../../user/services/user.service';
import { DependentService } from '../../../user/services/dependent.service';
import { RequestsService } from '../services/requests.service';
import { LoaderService } from '../../../../shared/services/loader.service';
import { Dependent } from '../../../user/models/user-profile.model';

@Component({
  selector: 'app-traslado-familiar',
  imports: [
    CommonModule,
    FormsModule,
    MatRadioModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './traslado-familiar.component.html',
  styleUrl: './traslado-familiar.component.scss'
})
export class TrasladoFamiliarComponent implements OnInit {
  selectedPatient = 'titular';
  nameOwner: string = '';
  phoneOwner: string = '';
  keyOwner: string = '';
  dependent: Dependent[] = [];
  userProfile: any;
  contactoDeTelefono: String = '0';
  serviceTitle: string = 'Traslado de un familiar';
  serviceDescription: string = 'Traslado de un familiar';

  constructor(
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private dependentService: DependentService,
    private requestServ: RequestsService,
    private loader: LoaderService
  ) {}

  ngOnInit() {
    const userData = localStorage.getItem('user');
    if (userData) {
      const userObj = JSON.parse(userData);
      this.nameOwner = userObj.name || '';
      this.phoneOwner = userObj.phone || '';
      this.keyOwner = userObj.memberships || '';
    }
    this.getServiceContact();
    this.getDetailUser();
    this.setServiceTitle();
    
    this.dependentService.direccionActualizada$.subscribe(() => {
      this.getDetailUser();
    });
  }

  getDetailUser() {
    const cognitoId = localStorage.getItem('cognito');
    if (cognitoId) {
      this.userService.getUserProfile(cognitoId).subscribe({
        next: (res) => {
          this.userProfile = res;
          this.dependent = res.dependents;
        },
        error: (err) => console.error('Error al obtener perfil', err)
      });
    }
  }

  isSelected(value: string): boolean {
    return this.selectedPatient === value;
  }

  addNewDependent() {
    this.router.navigate(['add-dependiente'], { queryParams: { returnUrl: this.router.url } });
  }

  solicitar() {
    this.generateExpediente();
  }

  generateExpediente() {
    this.loader.show();
    
    const selectedName = this.selectedPatient === 'titular' ? this.nameOwner : this.selectedPatient;
    const { firstName, lastName, secondLastName } = this.splitFullName(selectedName);
    
    const accountData = localStorage.getItem('account');
    const accountId = accountData ? JSON.parse(accountData) : 536;
    
    // Debug: verificar qué ID estamos obteniendo
    const routeId = this.route.snapshot.params['id'];
    const queryId = this.route.snapshot.queryParams['clSubServicio'];
    console.log('Route ID:', routeId);
    console.log('Query ID:', queryId);
    console.log('All route params:', this.route.snapshot.params);
    console.log('All query params:', this.route.snapshot.queryParams);
    console.log('Current URL:', this.router.url);
    
    // Intentar obtener el ID de diferentes formas
    const urlSegments = this.router.url.split('/');
    const serviceId = urlSegments[urlSegments.length - 1];
    console.log('Service ID from URL:', serviceId);
    
    const payload = {
      identifier: {
        tenants: 'adff7f6a-e97d-11eb-9a03-0242ac130003',
        app: 'PortalAsistencia'
      },
      petition: {
        serviceId: 6, // Asistencia en Viajes Internacional
        subServiceId: parseInt(this.route.snapshot.params['id']) || parseInt(this.route.snapshot.queryParams['clSubServicio']) || parseInt(serviceId),
        hasAssistance: false,
        key: this.keyOwner,
        areaCode1: '044',
        phone1: this.phoneOwner,
        stateCode: '',
        municipalityCode: '',
        statusId: 0,
        accountId: accountId,
        appUserId: 1,
        countryId: 115,
        contactTypeId: 15,
        serviceTypeId: 1,
        sendCharge: false,
        hasAppointment: false,
        isRelevant: false,
        gender: 1,
        isOk: true,
        hasQuotation: false,
        isSise2: true,
        serviceReceptionId: 10,
        personId: 1,
        username: this.nameOwner,
        paternalSurname: '',
        userSecondLastName: '',
        contactName: selectedName,
        userFirstNamePf: firstName,
        userLastNamePf: lastName,
        userSecondLastNamePf: secondLastName,
        ourUser: this.nameOwner,
        externalCabRepName: 'API CLIENTES',
        folio: crypto.randomUUID(),
        longitude: '',
        latitude: '',
        incidentDescription: this.serviceDescription,
        clRecepcionServicio: 10
      }
    };

    this.requestServ.sendHomeDoctorRequest(payload).subscribe({
      next: (res) => {
        this.loader.hide();
        console.log('Expediente generado:', res);
        
        const expediente = res?.response?.id || res?.data?.clExpediente || res?.clExpediente;
        
        const assistanceData = {
          clave: res.response.clave || '',
          clexpediente: expediente,
          nuestrousuario: res.response.nuestrousuario || this.nameOwner,
          clcuenta: res.response.clcuenta || '',
          nombre: this.serviceTitle,
          clservicio: res.response.clservicio || '6',
          dsservicio: 'Asistencia en Viajes Internacional',
          clsubservicio: res.response.clsubservicio || serviceId,
          dssubservicio: this.serviceDescription,
          clestatus: res.response.clestatus || '0',
          dsestatus: 'Abierto',
          fecharegistro: res.response.fecharegistro || new Date().toISOString()
        };
        
        const navigationExtras: NavigationExtras = {
          state: assistanceData,
          queryParams: assistanceData
        };
        
        this.router.navigate(['/solicitud/detalle/', expediente], navigationExtras).then(() => {
          setTimeout(() => {
            this.goToCall();
          }, 1000);
        });
      },
      error: (err) => {
        this.loader.hide();
        console.error('Error al generar expediente:', err);
      }
    });
  }

  private splitFullName(fullName: string) {
    const parts = fullName.trim().split(' ');
    return {
      firstName: parts[0] || '',
      lastName: parts[1] || '',
      secondLastName: parts.slice(2).join(' ') || ''
    };
  }

  private setServiceTitle(): void {
    const urlSegments = this.router.url.split('/');
    const serviceId = urlSegments[urlSegments.length - 1];
    
    const serviceMap: { [key: string]: { title: string, description: string } } = {
      '236': { 
        title: 'REPATRIACIÓN POR FALLECIMIENTO', 
        description: 'Repatriación por Fallecimiento' 
      },
      '239': { 
        title: 'TRASLADO DE UN FAMILIAR', 
        description: 'Traslado de un familiar' 
      }
    };
    
    const service = serviceMap[serviceId];
    if (service) {
      this.serviceTitle = service.title;
      this.serviceDescription = service.description;
    }
  }

  private getServiceContact(): void {
    try {
      const contacts = JSON.parse(localStorage.getItem('servicesContact') || '[]');
      const clSubServicio = parseInt(this.route.snapshot.params['id']) || parseInt(this.route.snapshot.queryParams['clSubServicio']);
      const serviceContact = contacts.find((c: any) => c.clSubServicio === clSubServicio);
      this.contactoDeTelefono = serviceContact?.phone || '0';
    } catch {
      this.contactoDeTelefono = '0';
    }
  }

  goToCall() {
    if (this.contactoDeTelefono && this.contactoDeTelefono !== '0') {
      window.open(`tel:${this.contactoDeTelefono}`, '_self');
    }
  }
}